function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M27.3086 17.3086C28.1992 16.4648 28.1992 15.0117 27.3086 14.168L19.8086 6.66797C18.9648 5.77734 17.5117 5.77734 16.668 6.66797L4.66797 18.668C3.77734 19.5117 3.77734 20.9648 4.66797 21.8086L9.16797 26.3086C9.54297 26.7305 10.1055 26.9648 10.7617 26.9648H27.4492C27.7305 26.9648 28.0117 26.7305 28.0117 26.4023V24.5273C28.0117 24.2461 27.7305 23.9648 27.4492 23.9648H20.6523L27.3086 17.3086ZM13.1523 14.4023L19.5742 20.8242L16.4336 23.9648H11.043L7.29297 20.2148L13.1523 14.4023Z",
  fill: "#D5D7DE"
});

var SvgEraser = function SvgEraser(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgEraser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eraser.278e888a.svg";
export { ForwardRef as ReactComponent };